import classNames from 'classnames';
import { _ } from '/@/locale';
import styles from './styles.module.css';

export const LayoutOption = ({ name, crop, country, image, children, footer, title }) => {
    return (
        <div className={styles.layoutOption}>
            {title && <p className={styles.title}>{title}</p>}
            {footer && (
                <div className={styles.content}>
                    {name && <div className={styles.name}>{name}</div>}
                    <p>{children}</p>
                </div>
            )}
            <div className={classNames(styles.image, styles[crop], styles[country], styles[`image-${image}`])} />
        </div>
    );
};

export const LayoutReference = ({ type, children }) => (
    <div className={styles.layoutReference}>
        <div className={styles[`dot${type}`]} />
        {children}
    </div>
);

export const LayoutReferences = ({ title, items }) => {
    return (
        <div className={styles.layoutReferences}>
            <div>
                <p>{title || _('Referencias')}</p>
                <div>
                    {items.map(({ type, name }) => (
                        <LayoutReference key={type} type={type}>
                            {name}
                        </LayoutReference>
                    ))}
                </div>
            </div>
        </div>
    );
};
